export default __webpack_public_path__ + "c77f4c6.png";